'use strict';
/*
  Is it possible to make a Tree View with Angular?
  http://stackoverflow.com/questions/11854514/is-it-possible-to-make-a-tree-view-with-angular
*/
angular.module('paizacloudApp')
  .directive('tree', function($timeout) {
    console.log("tree init");
    return {
      template: '<sub-tree node="node" class="jstree-default" xxxon-link="subTreeOnLink()"></sub-tree>',
      restrict: 'EA',
      scope: {
        node: '=',
        onDblclick: '&',
        onContextmenu: '&',
        isHidden: '&',
        load: '&',
        rename: '&',
        onClose: '&',
        onDrop: '&',
        onDragover: '&',
        onSelectNode: '&',
        onDragstart: '&',
        controller: '=',
      },
      controller: function($scope){
        this.select = (node, event) => {
          if(event && event.shiftKey && $scope.selectStart){
            $scope.selected = [];
            let selecting = false;
            let flipNodes = [$scope.selectStart, node];
            let dfs = (n) => {
              if(!selecting && flipNodes.indexOf(n) >= 0){
                flipNodes = flipNodes.filter((n2) => n2 !== n);
                selecting = !selecting;
              }
              n.selected = selecting;
              if(selecting){
                $scope.selected.push(n);
              }
              if(selecting && flipNodes.indexOf(n) >= 0){
                flipNodes = flipNodes.filter((n2) => n2 !== n);
                selecting = !selecting;
              }
              if(n.children instanceof Array){
                n.children.forEach((child) => {
                  dfs(child);
                });
              }
            };
            dfs($scope.node);
          }else if(event && event.metaKey){
            if(node.selected){
              node.selected = false;
              $scope.selected = $scope.selected.filter(function(n){return n !== node;});
            }else{
              node.selected = true;
              $scope.selected.push(node);
            }
          }else{
            $scope.selectStart = node;
            $scope.selected = [];
            let dfs2 = (n) => {
              if(n === node){
                $scope.selected.push(n);
                n.selected = true;
              }else{
                n.selected = false;
              }
              if(n.children instanceof Array){
                n.children.forEach(function(child){
                  dfs2(child);
                });
              }
            };
            dfs2($scope.node);
          }
          if($scope.onSelectNode) {
            $scope.onSelectNode({event: event, node: node});
          }
        };
        this.load = (node, callback = (() => {})) => {
          if($scope.load){
            $scope.load({node: node, callback: callback});
          }else{
            return callback();
          }
        };
        this.onClose = (node, callback) => {
          if($scope.onClose){
            $scope.onClose({node: node, callback: callback});
          }else{
            return callback();
          }
        };
        this.rename = (node, newName, callback) => {
          if($scope.rename){
            $scope.rename({node: node, newName: newName, callback: callback});
          }else{
            return callback();
          }
        };
        this.dblclick = (event, node) => {
          if(node.editting){
            return;
          }
          $scope.onDblclick({event: event, node: node});
        };
        this.contextmenu = (event, node) => {
          $scope.onContextmenu({event: event, node: node});
        };
        this.onDrop = (node, $event, files, cb) => {
          console.log('tree:onDrop: files', files);
          Array.from(files).forEach((file:any) => {
            if(file.$error){
              window.swal({
                title: 'File validation failed',
                text: `${file.$error} ${file.$errorParam}`,
                type: 'error',
              });
              return;
            }
          });
          if($scope.onDrop){
            $scope.onDrop({node: node, $event, '$files': files, callback: cb});
          }
        };
        this.onDragover = (node, $event) => {
          if($scope.onDragover){
            $scope.onDragover({node: node, $event});
          }
        };
        this.onDragstart = (event, node) => {
          console.log('tree:controller:onDragstart', event, node);
          $scope.onDragstart({event, node});
        };
        this.isHidden = (node) => {
          if(!$scope.isHidden){
            return false;
          }
          return $scope.isHidden({node: node});
        };
      },
      link: {
        pre: function(scope, element, attrs) {
          scope.xxxsubTreeOnLink = function(){
            // scope.node.scope.open();
          };
        },
        post: function(scope, element, attrs) {
          console.log("tree:link:post scope.node=", scope.node);
          scope.selected = [];
          scope.controller.getSelected = () => scope.selected;
        },
      },

    };
  });

/* http://stackoverflow.com/a/14657310/1309218 */
angular.module("paizacloudApp")
  .directive("recursive", function($compile) {
    return {
      restrict: "EACM",
      priority: 100000,

      compile: function(element, link:any){
        // Normalize the link parameter
        if(angular.isFunction(link)){
          link = { post: link };
        }

        // Break the recursion loop by removing the contents
        let contents = element.contents().remove();
        let compiledContents;
        return {
          pre: function(){
            let f = (link && link.pre) ? link.pre : null;
            if(f){
              f.apply(this, arguments);
            }
          },
          /**
           * Compiles and re-adds the contents
           */
          post: function(scope, element){
            // Compile the contents
            if(!compiledContents){
              compiledContents = $compile(contents);
            }
            // Re-add the compiled contents to the element
            compiledContents(scope, function(clone){
              element.append(clone);
            });

            // Call the post-linking function, if any
            if(link && link.post){
              link.post.apply(null, arguments);
            }
          },
        };
      },
    };
  });

angular.module("paizacloudApp")
  .directive("subTree", function($timeout, $http) {
    return {
      restrict: 'EA',
      // priority: 10,

      require: '^tree',
      templateUrl: 'app/tree.directive/tree.directive.html',
      scope: {
        node: '=',
        // onLink: '&',
        parentNode: '=',
        ngfDrag: '&',
        onDragstart: '&',
        onDragenter: '&',
        onDragleave: '&',
      },
      link: {
        pre: function(scope, element, attrs, treeCtrl) {
          console.log("subtree:link:pre");
        },
        post: function(scope, element, attrs, treeCtrl:any){
          if(!treeCtrl){
            throw new TypeError("treeCtrl is null.");
          }
          console.log("subtree:link:post");
          console.log("scope.node=", scope.node);

          const onContextMenuEventHandler = (event) => {
            console.log('onContextMenuEventHandler');
            if(!scope.node.selected){
              treeCtrl.select(scope.node, event);
            }
            treeCtrl.contextmenu(event, scope.node);
            event.preventDefault();
            event.stopPropagation();
          };

          element.bind('contextmenu', function(event){
            scope.$apply(() => {
              onContextMenuEventHandler(event);
            });

            event.stopPropagation();
            event.preventDefault();
          });
          element.bind('click', function(event){
            if(event.ctrlKey){
              console.log('cancel ctrl click event because this prevent contextmenu.');
              event.stopPropagation();
              event.preventDefault();
            }
          });

          let touchStartClearTimeout;
          element.on('touchstart', (event) => {
            const now = new Date().getTime();
            if(touchStartClearTimeout){
              clearTimeout(touchStartClearTimeout);
              touchStartClearTimeout = null;
            }

            function ignoreClickEvent(event){
              window.removeEventListener('click', ignoreClickEvent, true);
              event.stopPropagation();
              event.preventDefault();
            }

            touchStartClearTimeout = setTimeout(() => {
              scope.$apply(() => {
                onContextMenuEventHandler(event);
              });
              touchStartClearTimeout = null;
              window.addEventListener('click', ignoreClickEvent, true);
            }, 1000);

            const onTouchEnd = (event2) => {
              console.log('onTouchEnd');
              window.removeEventListener('touchend', onTouchEnd);
              if(touchStartClearTimeout){
                clearTimeout(touchStartClearTimeout);
                touchStartClearTimeout = null;
              }
            };
            window.addEventListener('touchend', onTouchEnd);

            event.stopPropagation();
            // event.preventDefault();
          });

          // attrs.$set('draggable', true);
          (element.children().attr as any)('draggable', true);
          element.children().on('dragstart', (event) => {
            console.log('dragstart...', event);
            event.stopPropagation();

            scope.$apply(() => {
              treeCtrl.onDragstart(event, scope.node);
            });
            element.addClass('dragging');
          });

          scope.isDragging = false;
          scope.isChildDragging = 0;

          scope.node.scope = scope;
          scope.node.parent = scope.parentNode;
          scope.load = (callback = (() => {})) => {
            scope.node.loading = true;
            treeCtrl.load(scope.node, (error, nodes) => {
              if (scope.node.loading){
                scope.node.children = nodes;
                scope.node.loading = false;
              }
              callback();
            });
          };
          scope.reload = (callback = $.noop) => {
            if(! scope.node.opened){
              return callback();
            }
            scope.node.loading = true;
            treeCtrl.load(scope.node, (error, nodes) => {
              if (scope.node.loading){
                if(scope.node.children instanceof Array) {
                  for (let i = 0; i < nodes.length; i++) {
                    let j = scope.node.children.findIndex((node) => node.id === nodes[i].id);
                    if (j >= 0) {
                      nodes[i] = scope.node.children[j];
                    }
                  }
                }
                scope.node.children = nodes;
                scope.node.loading = false;
                scope.node.children.forEach((node) => {
                  if(node.opened) {
                    node.scope.reload();
                  }
                });
              }
              callback();
            });
          };
          scope.open = (callback) => {
            if(scope.node.opened && scope.node.children instanceof Array){
              return callback();
            }
            scope.node.opened = true;

            scope.load(callback);
          };
          scope.close = function(){
            if(!scope.node.opened){
              return;
            }
            scope.node.opened = false;
            scope.node.loaded = false;
            scope.node.loading = false;
            scope.node.children = [];
            if(treeCtrl.onClose){
              treeCtrl.onClose(scope.node, () => {});
            }
          };

          scope.mousedown = (event) => {
            if(event.shiftKey){
              scope.select(event);
              event.stopPropagation();
              event.preventDefault();
            }
          };

          scope.select = (event) => {
            // console.log("tree.directive:select start", event);
            if(scope.node.selected){
              return;
            }
            if(scope.editClickStop){
              $timeout.cancel(scope.editClickStop);
              scope.editClickStop = null;
            }
            treeCtrl.select(scope.node, event);
            // console.log("tree.directive:select end", event);
          };
          scope.editClick = (event) => {
            if(scope.editClickStop){
              $timeout.cancel(scope.editClickStop);
              scope.editClickStop = null;
            }
            if(scope.node.selected){
              scope.editClickStop = $timeout(() => {
                scope.editClickStop = null;
                scope.edit(event);
              }, 800);
            }else{
              scope.edit(event);
            }
          };
          scope.delete = () => {
            scope.data.parent.children.splice(scope.node.parent.children.indexOf(scope.data), 1);
          };
          scope.add = () => {
            let post = scope.node.children.length + 1;
            let newName = scope.node.text + '-' + post;
            scope.node.children.push({text: newName, children: [], opened: true, parent: scope.node, id: scope.node.id + '/' + newName});
          };
          scope.edit = (event) => {
            scope.node.editting = true;
            scope.textInput = scope.node.text;
            $timeout(() => {
              // event.target.parentNode.querySelector('input').focus();
              element.find('input').focus();
            });
          };
          scope.unedit = function(){
            if(!scope.node.editting){
              return;
            }
            scope.node.editting = false;
            let newName = scope.parentNode.id + '/' + scope.textInput;
            treeCtrl.rename(scope.node, newName, (ok) => {
              console.log("rename done");
            });
          };
          scope.dblclick = (event) => {
            if(scope.editClickStop){
              $timeout.cancel(scope.editClickStop);
              scope.editClickStop = null;
            }

            console.log("dblclick!");
            if(scope.node.children){
              if(scope.node.opened){
                scope.close();
              }else{
                scope.open();
              }
            }else{
              treeCtrl.dblclick(event, scope.node);
            }
            event.preventDefault();
            event.stopPropagation();
          };

          scope.drag = (isDragging, _class, event) => {
            console.log("scope.drag:", isDragging);
            scope.$apply(() => {
              scope.isDragging = isDragging;
              scope.ngfDrag({'$isDragging': isDragging, '$class': _class, '$event': event});
            });
          };
          scope.childDrag = (isDragging, _class, event) => {
            console.log("childDrag", isDragging, scope.node.id);
            scope.isChildDragging += (isDragging ? 1 : -1);
          };
          scope.ngfDrop = ($event, files) => {
            /*
            treeCtrl.onDrop(scope.node, $event, files, function(){
              console.log("upload done");
            });
            */
          };

          if(scope.node.children) {
            const dropTargetElement = element.find('.drop-box');
            dropTargetElement[0].addEventListener('drop', (event) => {
              console.log('drop', scope.node.id, event, dropTargetElement[0], scope);
              scope.$apply(() => {
                scope.dragover--;
                scope.onDrop(event);
              });
              event.stopPropagation();
              event.preventDefault();
            });
            dropTargetElement[0].addEventListener('dragover', (event) => {
              scope.$apply(() => {
                scope.onDragover(event);
              });
              event.stopPropagation();
              event.preventDefault();
            });

            scope.dragover = 0;
            dropTargetElement[0].addEventListener('dragenter', (event) => {
              console.log('dragenter', scope.node.id, event, dropTargetElement[0], scope);
              scope.$apply(() => {
                scope.dragover++;
                // scope.onDragenter({});
              });
              event.stopPropagation();
              // event.preventDefault();
            });
            dropTargetElement[0].addEventListener('dragleave', (event) => {
              console.log('dragleave', scope.node.id, event, dropTargetElement[0], scope);
              scope.$apply(() => {
                scope.dragover--;
                // scope.onDragleave({});
              });
              event.stopPropagation();
              // event.preventDefault();
            });
          }

          scope.onDrop = ($event) => {
            const dataTransfer = $event.dataTransfer;
            const files = dataTransfer.files;
            treeCtrl.onDrop(scope.node, $event, files, function(){
              console.log("upload done");
            });
          };
          scope.onDragover = ($event) => {
            treeCtrl.onDragover(scope.node, $event);
          };
          scope.isHidden = () => {
            if(!treeCtrl.isHidden){
              return false;
            }
            return treeCtrl.isHidden(scope.node);
          };

          /*
          if(scope.node.opened && !(scope.node.children instanceof Array)){
            scope.load(() => {});
          }
          */
          scope.reload(() => {
            scope.$emit('loaded');
          });
          console.log('subtree link-end');
          scope.$emit('link-end');
          /*
          if(scope.onLink){
            // console.log("calling onLink");
            scope.onLink();
          }
          */
        },
      },
    };
  });
